import { extend, override } from 'flarum/common/extend';
/**
 * flarum/deck's hero can be dismissed for good (per browser), unlike the
 * other page heroes, and the page then sits higher than Tags, Messages or
 * the user directory. Its close button goes, and a hero dismissed before
 * comes back.
 */
export default function deckHero() {
  extend('ext:flarum/deck/forum/components/DeckPageHero', 'bodyItems', function (items) {
    if (items.has('dismiss-button')) items.remove('dismiss-button');
  });
  flarum.reg.onLoad('flarum-deck', 'forum/components/DeckPageHero', DeckPageHero => {
    override(DeckPageHero, 'isHidden', () => false);
  });
}